import Crud from '../components/RoomsDetails/Crud'
import Entity from '../components/RoomsDetails/Add'

let routes = {
    path: '/room_details',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/room_details/add',
            name: 'Novo Adicional',
            component: Entity
        },
        {
            path: '/room_details/edit/:id?',
            name: 'Editar Adicional',
            component: Entity
        },
        {
            path: '/room_details',
            name: 'Adicionais da Sala',
            component: Crud
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/room_details.js